@if (itemsComponent.itemsInnerComponent().getElements().length === 0) {
  <app-empty-sidebar />
}
<app-items
  #itemsComponent
  [sidebarComponent]="sidebarComponent()"
  [instancesComponent]="instancesComponent()"
/>
